import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FC, useEffect, useState } from 'react'
import { Button, Col, Form, InputGroup, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { MediaEndPointProps } from '../APIManager.d'

const MediaEndpoint: FC<MediaEndPointProps> = ({ version }) => {
    const [fileSource, setFileSource] = useState<string>('')
    const [fileId, setFileId] = useState<string>('')
    const [imageWidth, setImageWidth] = useState<string>('')
    const [fileExists, setFileExists] = useState<boolean>(true)
    const [fileUrl, setFileUrl] = useState<string>('')
    const [originalFileUrl, setOriginalFileUrl] = useState<string>('')

    useEffect(() => {
        setFileUrl(
            `${
                process.env.REACT_APP_CLIENT_API_ROOT
            }/${version}/media/download/${fileId}${
                imageWidth ? '/' + imageWidth : ''
            }`
        )
        setOriginalFileUrl(
            `${process.env.REACT_APP_CLIENT_API_ROOT}/${version}/media/download/${fileId}`
        )
    }, [fileId, imageWidth, version])

    const checkFileExists = (url: string) => {
        var http = new XMLHttpRequest()

        http.open('HEAD', url, false)
        http.send()

        return http.status !== 404
    }

    return (
        <Row>
            <Col xl={12}>
                <InputGroup className="mb-3">
                    <InputGroup.Text className="px-4">GET</InputGroup.Text>
                    <div className="form-control readonly">{fileUrl}</div>
                    <Button
                        variant="primary"
                        className="px-4"
                        disabled={!fileId}
                        onClick={() => {
                            setFileExists(checkFileExists(fileUrl))
                            setFileSource(fileUrl)
                        }}
                    >
                        Run
                    </Button>
                </InputGroup>
            </Col>
            <Col xl={3} lg={4}>
                <h6>Parameters</h6>
                <Form.Group className="mb-3 sfy-field">
                    <Form.Label className="w-100">File Id</Form.Label>
                    <Form.Control
                        type="text"
                        value={fileId}
                        onChange={(e) => setFileId(e.target.value)}
                    />
                </Form.Group>
                <Form.Group className="mb-3 sfy-field">
                    <Form.Label className="w-100">
                        Image width in pixels (optional)
                    </Form.Label>

                    <InputGroup className="mb-3">
                        <Form.Control
                            type="text"
                            value={imageWidth}
                            onChange={(e) => {
                                setFileSource('')
                                setImageWidth(e.target.value)
                            }}
                        />
                        <InputGroup.Text>px</InputGroup.Text>
                    </InputGroup>
                </Form.Group>
            </Col>
            <Col xl={9} lg={8}>
                {fileSource ? (
                    <>
                        {!fileExists ? (
                            <h6 className="text-danger">
                                <FontAwesomeIcon
                                    icon={faExclamationTriangle}
                                    className="me-2"
                                />
                                File does not exist!
                            </h6>
                        ) : (
                            <>
                                {imageWidth ? (
                                    <>
                                        <h6>
                                            View / Download the file{' '}
                                            <Link
                                                target="_blank"
                                                to={originalFileUrl}
                                            >
                                                Original
                                            </Link>{' '}
                                            {' | '}{' '}
                                            <Link
                                                target="_blank"
                                                to={fileSource}
                                            >
                                                Resized
                                            </Link>{' '}
                                            (open in a new window)
                                        </h6>
                                    </>
                                ) : (
                                    <>
                                        <h6>
                                            View / Download the file{' '}
                                            <Link
                                                target="_blank"
                                                to={originalFileUrl}
                                            >
                                                Here
                                            </Link>{' '}
                                            (open in a new window)
                                        </h6>
                                    </>
                                )}

                                <img
                                    alt="API File Preview"
                                    src={fileSource}
                                    className="mw-100"
                                />
                            </>
                        )}
                    </>
                ) : (
                    <></>
                )}
            </Col>
        </Row>
    )
}

export default MediaEndpoint
